import { commonRoutesConstants } from "services/keyConstants";

let correctiveBaseUrl = "/corrective-action";
let preventiveBaseUrl = "/preventive-action";

export const GET_CA_DASHBOARD_COUNTS = `${correctiveBaseUrl}/get-counts`;
export const GET_CA_NC_CLOSURE_DATA = `${correctiveBaseUrl}/get-nc-closure-data`;
export const GET_PA_DASHBOARD_COUNTS = `${preventiveBaseUrl}/get-counts`;
export const GET_PA_NC_CLOSURE_DATA = `${preventiveBaseUrl}/get-nc-closure-data`;
export const CREATE_CORRECTIVE_ACTION = `${correctiveBaseUrl}`;

export const GET_ALL_CORRECTIVE_ACTION = `${correctiveBaseUrl}`;

export const GET_ALL_CORRECTIVE_ACTION_BY_ID = `${correctiveBaseUrl}/`;

export const UPDATE_CORRECTIVE_ACTION_BY_ID = `${correctiveBaseUrl}/`;

export const UPDATE_CORRECTIVE_ACTION_SPECIFIC = `${correctiveBaseUrl}/specific/`;

export const GET_ALL_PREVENTIVE_ACTION_BY_ID = `${preventiveBaseUrl}/`;

export const DOWNLOAD_CORRECTIVE_ACTION = `${correctiveBaseUrl}/download`;

export const DOWNLOAD_PREVENTIVE_ACTION = `${preventiveBaseUrl}/download`;

export const GET_BY_YEAR = `${correctiveBaseUrl}/${commonRoutesConstants.YEAR_LIST}`;

export const GET_BY_YEAR_PREVENTIVE_ACTION = `${preventiveBaseUrl}/${commonRoutesConstants.YEAR_LIST}`;
